import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import { Link, useParams, useNavigate } from "react-router-dom";
// import useHistory from "react-router";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { checkUserPermission } from "../../../../common/UserPermission";

const ItemNotCounted = (props) => {
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const paramObject = useParams();
  const [data, setData] = useState();
  console.log("dataaaa", data);
  useEffect(() => {
    axios
      .get(`${config.itemsBaseUrl}/items/itemnotcountedlisting`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("res ==> ", res.data.ResponseData);
        setData(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("err ==>", err);
      });
  }, []);

  // Dropdown Styles
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      // position: "absolute",
      background: "#f8f8f8",
      width: "100%",
    }), // dropdown menu css
  };

  const [dataToSend, setDataToSend] = useState([]);
  // export dataToSend;
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const Changeddata = [...data];
    Changeddata[index] = {
      ...Changeddata[index],
      [name]: parseInt(value),
    };
    setData(Changeddata);
  };

  useEffect(() => {
    const filteredData = data?.filter((item) => item.Count);
    console.log("filteredDataaa::>>>", filteredData);
    setDataToSend(filteredData);
  }, [data]);

  const navigate = useNavigate();

  const handleNavigateToPage2 = () => {
    navigate(`/new-inventory-count/${paramObject.id}`, {
      state: { dataToSend },
    });
  };

  const handleSaveDataClick = (row) => {
    // const obj = {

    // }
    axios
      .post(
        `${config.itemsBaseUrl}/items/notcountedupdatecount`,
        {
          Id: row.InventoryCountsItemsId, // row.Id,
          Counts: row.Counts,
          ItemId: row.ItemId,
          ItemVariationId: row.ItemVariationId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(true);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess("Data Updated Successfully");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Something Went Wrong");
        } else {
          toastError("Something Went Wrong");
        }
        setLoading(false);
        // window.location.href = window.location.href;
      })
      .catch((error) => {
        setLoading(false);
        // console.log("error: ", error);
      });
    console.log("rowDATAAAAA", row);
  };

  // Table Data
  const columns = [
    {
      name: "Item Name",
      selector: (row) => row.ItemName,
      width: "10%",
      sortable: true,
    },
    {
      name: "Category Full Path",
      selector: (row) => row.CatergoryFullPath,
      sortable: true,
      width: "20%",
    },
    {
      name: "Item Number",
      selector: (row) => row.ItemNumber,
      sortable: true,
      width: "10%",
    },
    {
      name: "Product Id",
      selector: (row) => row.ProductId,
      sortable: true,
      width: "10%",
    },
    checkUserPermission('show-cost-price') &&(
    {
      name: "Cost Price",
      selector: (row) => row.CostPrice ? parseFloat(row.CostPrice).toFixed(2): 0,
      sortable: true,
      // width: "10%",
    }),
    {
      name: "Unit Price",
      selector: (row) => row.UnitPrice ? parseFloat(row.UnitPrice).toFixed(2): 0,
      sortable: true,
      // width: "10%",
    },
    {
      name: "Actual On Hand",
      selector: (row) =>row.ItemActualOnHand ? parseFloat(row.ItemActualOnHand).toFixed(2) : 0 ,
      sortable: true,
      // width: "17%",
    },
    {
      name: "Count",
      selector: (row, index) => (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Enter Count"
            name="Counts"
            value={parseInt(row.Counts ? row.Counts : 0)}
            onChange={(e) => handleChange(e, index)}
          ></input>
        </>
      ),
      // sortable: true,
      // width: "17%",
      width: "10%",
    },
    {
      name: "Action",
      selector: (row, index) => (
        <>
          {/* <input
            className="form-control"
            placeholder="Enter Count"
            name="Counts"
            value={row.Counts}
            onChange={(e) => handleChange(e, index)}
          ></input> */}
          <button
            className="btn btn-sm btn-custom-padding btn-primary"
            onClick={() => handleSaveDataClick(row)}
          >
            Save
          </button>
        </>
      ),
      // sortable: true,
      width: "17%",
    },
  ];

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>New Count Inventory</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/item-count-invetory">Count Inventory</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/new-inventory-count/${paramObject.id}`}>
                    New Inventory Count
                  </Link>
                </li>
                <li className="breadcrumb-item active">Item Not Counted</li>
              </ul>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="card-body">
                <div className="d-flex flex-row-reverse mb-3">
                  <div className="p-2">
                    {/* <Link
                      className="btn btn-info"
                      // to={`/new-inventory-count/${paramObject.id}`}
                      onClick={handleNavigateToPage2}
                    >{`<< Back`}</Link> */}
                    <button
                      onClick={handleNavigateToPage2}
                      className="btn btn-sm btn-dark"
                    >{`<< Back`}</button>
                  </div>
                  {/* <div className="p-2">
                    <Link className="btn btn-sm btn-info">Print</Link>
                  </div> */}
                </div>
                {/* <div className="col-md-12 mb-4">
                  <Select
                    // onChange={(event) => {
                    //   handleDropDown(event, "TaxGroup");
                    // }}
                    // value={taxGroupOptions.find(
                    //   (option) => option?.value == selectedTaxGroup
                    // )}
                    // options={taxGroupOptions}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={selectStyles}
                    id="AllCategories"
                    name="AllCategories"
                  />
                </div> */}
                <div className="table-responsive">
                  <DataTable
                    title="Item Not Counted"
                    columns={columns}
                    data={data}
                    // progressPending={loading}
                    pagination
                    paginationServer
                    // paginationTotalRows={totalRows}
                    // paginationDefaultPage={currentPage}
                    // onChangeRowsPerPage={(e) => {
                    //   handlePerRowsChange(1, e);
                    // }}
                    // onChangePage={handlePageChange}
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    fixedHeader
                    // fixedHeaderScrollHeight="70vh"
                    persistTableHead
                    sortServer
                    // onSort={handleSort}
                    // selectableRows
                    // onSelectedRowsChange={e => { handleSelectedRowsChange(e); }}
                    // contextActions={contextActions}
                    // onSelectedRowsChange={handleRowSelected}
                    // clearSelectedRows={toggleCleared}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemNotCounted;
